// Single chat message bubble, sent or received.

import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Drafty, Tinode } from 'tinode-sdk';

import Attachment from './attachment.jsx';
import LetterTile from './letter-tile.jsx';
import ReceivedMarker from './received-marker.jsx'

import { fullFormatter } from '../lib/formatters.js';
import { sanitizeUrl } from '../lib/utils.js';

class BaseChatMessage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      progress: 0
    };

    if (props.uploader) {
      props.uploader.onProgress = this.handleProgress.bind(this);
    }

    this.handleExpandImage = this.handleExpandImage.bind(this);
    this.handlePlayVideo = this.handlePlayVideo.bind(this);
    this.handleFormButtonClick = this.handleFormButtonClick.bind(this);
    this.handleContextClick = this.handleContextClick.bind(this);
    this.handleCancelUpload = this.handleCancelUpload.bind(this);
    this.handleQuoteClick = this.handleQuoteClick.bind(this);
    this.handleSurveyClick = this.handleSurveyClick.bind(this);
    this.removeFinishTagsFromTree = this.removeFinishTagsFromTree.bind(this);

    

    this.formatterContext = {
      formatMessage: props.intl.formatMessage.bind(props.intl),
      viewportWidth: props.viewportWidth,
      authorizeURL: props.tinode.authorizeURL.bind(props.tinode),

      onImagePreview: this.handleExpandImage,
      onVideoPreview: this.handlePlayVideo,
      onFormButtonClick: this.handleFormButtonClick,
      onQuoteClick: this.handleQuoteClick
    };
  }

  handleExpandImage(e) {
    e.preventDefault();
    this.props.onExpandMedia({
      url: e.target.src,
      filename: e.target.dataset.name,
      width: e.target.dataset.width,
      height: e.target.dataset.height,
      size: e.target.dataset.size,
      type: e.target.dataset.mime
    });
  }

  handlePlayVideo(e) {
    e.preventDefault();
    this.props.onExpandMedia({
      video: true,
      url: e.target.dataset.src,
      preview: e.target.src,
      filename: e.target.dataset.name,
      width: e.target.dataset.width,
      height: e.target.dataset.height,
      duration: e.target.dataset.duration,
      size: e.target.dataset.size,
      type: e.target.dataset.mime
    });
  }

  handleFormButtonClick(e) {
    e.preventDefault();
    const data = {
      seq: this.props.seq
    };
    data.resp = {};
    if (e.target.dataset.name) {
      data.resp[e.target.dataset.name] = e.target.dataset.val ? e.target.dataset.val :
        e.target.dataset.val === undefined ? 1 : '' + e.target.dataset.val;
    }
    if (e.target.dataset.act == 'url') {
      data.ref = sanitizeUrl(e.target.dataset.ref) || 'about:blank';
    }
    const text = e.target.dataset.title || 'unknown';
    this.props.onFormResponse(e.target.dataset.act, text, data);
  }

  handleContextClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const menuItems = [];
    if (this.props.received == Tinode.MESSAGE_STATUS_FAILED) {
      menuItems.push('menu_item_send_retry');
    }
    if (this.props.userIsWriter && this.props.received > Tinode.MESSAGE_STATUS_FATAL) {
      menuItems.push('menu_item_reply');
      if (!this.props.response) {
        let immutable = false;
        Drafty.entities(this.props.content, (_0, _1, tp) => {
          immutable = ['AU', 'EX', 'FM', 'IM', 'VC', 'VD'].includes(tp);
          return immutable;
        });
        if (!immutable) {
          Drafty.styles(this.props.content, tp => {
            immutable = ['QQ'].includes(tp);
            return immutable;
          });
        }
        if (!immutable) {
          menuItems.push('menu_item_edit');
        }
      }
    }
    menuItems.push('menu_item_forward');

    this.props.showContextMenu({
      seq: this.props.seq,
      replace: this.props.edited ? parseInt(this.props.edited.split(':')[1]) : 0,
      content: this.props.content,
      userFrom: this.props.userFrom,
      userName: this.props.userName,
      y: e.pageY,
      x: e.pageX,
      pickReply: this.props.pickReply,
      editMessage: this.props.editMessage,
    }, menuItems);
  }

  handleProgress(ratio) {
    this.setState({progress: ratio});
  }

  handleCancelUpload() {
    this.props.onCancelUpload(this.props.seq, this.props.uploader);
  }

  handleQuoteClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const replyToSeq = this.props.replyToSeq;
    if (replyToSeq) {
      this.props.onQuoteClick(replyToSeq);
    }
  }

  handleSurveyClick = (event) => {
    event.preventDefault(); // Предотвращение стандартного поведения ссылки
    if (this.props.toggleSurvey) {
      this.props.toggleSurvey(); // Вызов onCreate, если он предоставлен
    }
  }
  removeFinishTagsFromTree2(tree) {
    
    // Проверка, что это массив
    if (Array.isArray(tree)) {
      // Пробегаемся по каждому элементу массива
      return tree.map(element => {
        // Если элемент — строка, удаляем из неё теги
        if (typeof element === 'string') {
          return element.replace(/\$\$finish(?: \d+)?\$\$/g, '');
        }
        // Если элемент — массив, рекурсивно обрабатываем вложенный массив
        if (Array.isArray(element)) {
          return this.removeFinishTagsFromTree(element);
        }
        // Если элемент объект или React элемент, возвращаем его как есть
        return element;
      });
    }
    return tree; // Если не массив, просто возвращаем оригинальное значение
  }
  
    
  removeFinishTagsFromTree(tree, processed = new WeakSet()) {
    // Если объект уже был обработан, возвращаем его без изменений
    if (processed.has(tree)) {
      return tree;
    }
  
    // Добавляем объект в список обработанных, чтобы избежать циклической ссылки
    if (typeof tree === 'object' && tree !== null) {
      processed.add(tree);
    }
  
    // Проверка, что это массив
    if (Array.isArray(tree)) {
      return tree.map(element => {
        // Если элемент — строка, удаляем из неё теги
        if (typeof element === 'string') {
          return element.replace(/\$\$finish(?: \d+)?\$\$/g, '');
        }
        // Если элемент — массив, рекурсивно обрабатываем вложенный массив
        if (Array.isArray(element)) {
          return this.removeFinishTagsFromTree(element, processed);
        }
        // Если элемент объект, рекурсивно обрабатываем его свойства
        if (typeof element === 'object' && element !== null) {
          return this.removeFinishTagsFromTree(element, processed);
        }
        // Если элемент React элемент, возвращаем его как есть, но проверяем его children
        return element;
      });
    }
  
    // Если это React-элемент, обрабатываем его children
    if (typeof tree === 'object' && tree !== null && tree.$$typeof && tree.$$typeof.toString().includes('react.element')) {
      const newProps = { ...tree.props };
  
      // Рекурсивно обрабатываем children, если они есть
      if (newProps.children) {
        newProps.children = this.removeFinishTagsFromTree(newProps.children, processed);
      }
  
      // Возвращаем новый React элемент с обработанными children
      return {
        ...tree,
        props: newProps
      };
    }
  
    // Если это объект, рекурсивно обрабатываем его свойства
    if (typeof tree === 'object' && tree !== null) {
      const newObject = {};
      for (let key in tree) {
        if (tree.hasOwnProperty(key)) {
          newObject[key] = this.removeFinishTagsFromTree(tree[key], processed);
        }
      }
      return newObject;
    }
  
    return tree; // Если не массив, не объект, и не React-элемент, просто возвращаем оригинальное значение
  }
  
  
  
  
  

  
  render() {
    const sideClass = this.props.sequence + ' ' + (this.props.response ? 'left' : 'right');
    const bubbleClass = (this.props.sequence == 'single' || this.props.sequence == 'last') ? 'bubble tip' : 'bubble';
    const avatar = this.props.userAvatar || true;
    const fullDisplay = (this.props.isGroup && this.props.response &&
      (this.props.sequence == 'single' || this.props.sequence == 'last'));

    let content = this.props.content;

    const attachments = [];
    if (this.props.mimeType == 'error/json' ) {

      if (  this.props.isLast) {
        //console.info("error: ", content);
        let errCode = "Unknow error: try again later";
  
        if (  (this.props.TokensUsed <=50000 && this.props.Tokens - this.props.TokensUsed > 13000 
                || this.props.TokensUsed >50000 && this.props.Tokens - this.props.TokensUsed > 30000)
              && content && content.Error  && content.Error == "token_mylimit") {
          content = <><i className="material-icons gray">done_outline</i> <i className="gray">
          <FormattedMessage id="error.chat.mylimit.enough" /></i> <br/> <br/> <button id='linkTopUp' className='link'  style={{ marginLeft: '5px' }}
                      onClick={() => {this.props.repeatAskingGTP();}}>
                      <FormattedMessage id="message.repeat" defaultMessage="Repeat last message" description="repeat"/>
                </button> </>

        } else if (content && content.Error  && content.Error == "token_mylimit") {
          content = <><i className="material-icons gray">warning_amber</i> <i className="gray">
          <FormattedMessage id="error.chat.mylimit" /></i> <button id='linkTopUp' className='link'  style={{ marginLeft: '5px' }}
                      onClick={() => {this.props.onAddTokens();}}>
                      <FormattedMessage id="topup" defaultMessage="Top up" description="Top up"/>
                </button> 
                {this.props.Survey == -1 && //this.props.TokensUsed > 3000 && this.props.Tokens <= 15000 && 
                <div className="center-text padding-all-small">
                    <a href="#" onClick={this.handleSurveyClick} > { <FormattedMessage id="tabtitle_survey" defaultMessage="Complete the survey and get 5000 tokens for free" description="Complete the survey and get 5000 tokens for free" /> } </a>
                </div>}
                </>
        } else if (content && content.Error  && content.Error == "end_dialog") {
          content = <><i className="material-icons gray">info</i> <i className="gray">
          <FormattedMessage id="error.chat.end.dialog" /></i></>
        } else if (content && content.Error) {
          content = <><i className="material-icons gray">warning_amber</i> <i className="gray">
          <FormattedMessage id="error.chat.general" /></i></>
        }

     } else {
      return;
     }

    } else  if (this.props.mimeType == Drafty.getContentType() && Drafty.isValid(content)) {
      Drafty.attachments(content, (att, i) => {
        if (att.mime == 'application/json') {
          // Don't show json objects as attachments.
          // They are not meant for users.
          return;
        }
        attachments.push(<Attachment
          tinode={this.props.tinode}
          downloadUrl={Drafty.getDownloadUrl(att)}
          filename={att.name}
          uploading={Drafty.isProcessing(att)}
          mimetype={att.mime}
          size={Drafty.getEntitySize(att)}
          progress={this.state.progress}
          onCancelUpload={this.handleCancelUpload}
          onError={this.props.onError}
          key={i} />);
      }, this);
      
      const tree = Drafty.format(content, fullFormatter, this.formatterContext);
      //console.info(" Drafty.format(tree: ", tree);
      const cleanedTree = this.removeFinishTagsFromTree(tree);
      content = React.createElement(React.Fragment, null, cleanedTree);
      
      //content = React.createElement(React.Fragment, null, tree);
    } else if (typeof content != 'string') {
      content = <><i className="material-icons gray">warning_amber</i> <i className="gray">
        <FormattedMessage id="invalid_content"
          defaultMessage="invalid content" description="Shown when the message is unreadable" /></i></>
    } else if (typeof content == 'string' && content != null) {
      content = content.replace(/$$finish(?: \d+)?$$/g, '')
    }

    return (
      <li ref={this.props.innerRef} className={sideClass}>
        {this.props.isGroup && this.props.response ?
          <div className="avatar-box">
            {fullDisplay ?
              <LetterTile
                tinode={this.props.tinode}
                topic={this.props.userFrom}
                title={this.props.userName}
                avatar={avatar} /> :
              null}
          </div> :
          null}
        <div>
          <div className={bubbleClass}>
            <div className="content-meta">
              <div className="message-content">
                {content}
                
                {attachments}
              </div>
              {this.props.timestamp ?
                <ReceivedMarker
                  edited={this.props.edited}
                  timestamp={this.props.timestamp}
                  received={this.props.received} />
                : null}
            </div>
            {this.props.showContextMenu ?
              <span className="menuTrigger">
                <a href="#" onClick={this.handleContextClick}>
                  <i className="material-icons">expand_more</i>
                </a>
              </span> : null
            }
          </div>
          {fullDisplay ?
            <div className="author">
              {this.props.userName ||
                <i><FormattedMessage id="user_not_found" defaultMessage="Not found"
                description="In place of a user's full name when the user is not found." /></i>
              }
            </div>
            : null
          }
        </div>
      </li>
    );
  }
};

const IntlChatMessage = injectIntl(BaseChatMessage);
const ChatMessage = React.forwardRef((props, ref) => <IntlChatMessage innerRef = {ref} {...props} />);

export default ChatMessage;
